var _style, _g, _g2, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParticipate = function SvgParticipate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".participate_svg__st0,.participate_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.participate_svg__st1{fill:#8caed2}")), /*#__PURE__*/React.createElement("g", {
    id: "participate_svg__Mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "participate_svg__ra_foerderpreis_mobile_var01_v02_TCB",
    transform: "translate(-174 -563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "participate_svg___x30_1_x5F_hero",
    transform: "translate(12 43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "participate_svg__button-mitmachen",
    transform: "translate(232 590)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "participate_svg__Oval-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "participate_svg__Oval",
    className: "participate_svg__st0",
    cx: 30,
    cy: 30,
    r: 100
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "participate_svg__Group-61",
    transform: "translate(18 18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-1",
    className: "participate_svg__st1",
    d: "m-73.69-5.87 10.88 2.13c1.08.21 1.97.53 2.68.95.71.42 1.21 1.01 1.52 1.76.31.75.35 1.67.14 2.77-.13.67-.39 1.43-.78 2.28l-2.73-.61c.27-.53.45-.99.53-1.39.16-.8.02-1.39-.42-1.78-.43-.39-1.06-.67-1.88-.83L-74.3-2.66l.61-3.21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-3",
    className: "participate_svg__st1",
    d: "m-56.24-15.9 2.46.88-3.17 9.15-15.08-5.39 3.14-9.06 2.48.89-2.07 5.97 3.65 1.3 1.89-5.47 2.46.88-1.89 5.47 4.03 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-5",
    className: "participate_svg__st1",
    d: "m-49.22-22.48-1.63 2.92-11.96-6.79-2.3 4.12-2.36-1.34 6.25-11.2 2.36 1.34-2.32 4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-7",
    className: "participate_svg__st1",
    d: "m-39.33-36.4-7.27 8.47-2.18-1.72-3.14-10.89c-.1-.34-.18-.63-.24-.87a2.84 2.84 0 0 1-.08-.7c-.06.11-.11.2-.15.25-.12.14-.21.25-.28.34-.07.09-.15.19-.23.29l-4.12 4.8-2.08-1.64 6.95-8.11 2.37 1.87 3.21 11.04c.12.38.19.75.22 1.11.21-.31.43-.61.68-.9l4.27-4.98 2.07 1.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-9",
    className: "participate_svg__st1",
    d: "M-32.49-41.46-35-39.33l-8.9-10.3-3.56 3.01-1.76-2.03 9.66-8.17 1.76 2.03-3.59 3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-11",
    className: "participate_svg__st1",
    d: "m-5.11-56.11-3 1.23-3.52-8.96c-.49-1.38-.96-2.77-1.42-4.18l-.09.04c.09.66.15 1.25.17 1.76l.73 13.02-2.76 1.14-6.94-8.16c-.87-1.02-1.67-2.07-2.43-3.15l-.09.04c.72 1.41 1.32 2.7 1.79 3.9l3.57 9.07-2.85 1.17-5.97-15.16 4.75-1.94 5.83 6.85c.92 1.11 1.73 2.22 2.42 3.34-.12-.69-.21-1.29-.28-1.81-.07-.52-.12-1.05-.15-1.58l-.54-9.78 4.81-1.97 5.97 15.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-13",
    className: "participate_svg__st1",
    d: "m.21-56.68-3.13.62-2.95-16.11 3.13-.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-15",
    className: "participate_svg__st1",
    d: "m9.91-57.76-3.33.18-.75-13.61-4.71.25-.15-2.68 12.78-.69.15 2.68-4.74.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-17",
    className: "participate_svg__st1",
    d: "m33.97-55.3-3.17-.56 1.62-9.37c.29-1.42.61-2.83.95-4.25l-.09-.02c-.26.6-.51 1.12-.76 1.57l-6.08 11.3-2.92-.52-1.67-10.52a40.34 40.34 0 0 1-.43-3.93l-.09-.02c-.11 1.56-.28 2.96-.49 4.21l-1.64 9.49-3.01-.53 2.74-15.87 5.01.89 1.41 8.83c.21 1.42.32 2.78.34 4.08.25-.64.48-1.2.7-1.67.21-.47.44-.94.69-1.41l4.57-8.48 5.08.9-2.76 15.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-19",
    className: "participate_svg__st1",
    d: "m46.72-55.98.49-6.1c.01-.14.06-.5.16-1.11-.16.2-.32.4-.49.6-.16.2-.3.36-.4.48l-4.08 4.16 4.32 1.97zm2.82 8.28-3.28-1.49.25-3.94-6.15-2.8-2.82 2.77-3.1-1.41 12.63-12.14 3.34 1.52-.87 17.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-21",
    className: "participate_svg__st1",
    d: "m61.23-43.18-1.61 2.32c-1.33-.48-2.46-1.04-3.39-1.67-1.05-.72-1.93-1.51-2.63-2.38-.7-.87-1.18-1.81-1.45-2.81s-.29-2.03-.05-3.08c.24-1.05.76-2.09 1.55-3.14.79-1.04 1.66-1.86 2.62-2.46.95-.6 1.96-.97 3.02-1.11 1.06-.14 2.14-.06 3.24.26 1.1.31 2.2.84 3.29 1.59.98.66 1.92 1.59 2.84 2.77l-1.88 2.04a6.945 6.945 0 0 0-2.37-2.66c-.88-.6-1.8-.95-2.74-1.05-.94-.1-1.84.05-2.69.45-.85.4-1.59 1.02-2.22 1.85-.66.87-1.06 1.78-1.21 2.73-.15.95-.02 1.85.39 2.71.41.86 1.08 1.6 2.02 2.24.89.6 1.98 1.07 3.27 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-23",
    className: "participate_svg__st1",
    d: "m69.75-30.21-2.19-2.41 5.09-4.71-4.32-4.76-5.09 4.72-2.19-2.41 11.83-10.96 2.19 2.41-4.81 4.45 4.32 4.76 4.81-4.45 2.19 2.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-25",
    className: "participate_svg__st1",
    d: "m78.78-20.94-2.19 1.38-4.89-8.28 13.4-8.45 4.85 8.2-2.21 1.39-3.19-5.4-3.24 2.04 2.92 4.95-2.19 1.38-2.92-4.95-3.58 2.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-27",
    className: "participate_svg__st1",
    d: "M82.34-4.35 81-8.08l7.36-8.43c.46-.54 1.21-1.29 2.23-2.26-1.5.82-2.76 1.41-3.79 1.79l-7.96 2.93L77.78-17l15.21-5.61 1.32 3.66-7.34 8.56c-.26.3-.45.5-.57.61-.12.11-.35.31-.69.62-.34.3-.68.61-1.02.92.99-.58 2.2-1.13 3.62-1.65l8.18-3.02 1.06 2.95-15.21 5.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-29",
    className: "participate_svg__st1",
    d: "m87.52 1.37-.49-2.41 11.35-2.55.69 3.38-11.55 1.58zm-1.6.59-2.97.53-.61-2.97 2.97-.53.61 2.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-31",
    className: "participate_svg__st1",
    d: "m-57.58 31.87-10.52 2.32c-1.05.23-1.97.3-2.76.21a3.5 3.5 0 0 1-2.04-.93c-.57-.53-.97-1.31-1.21-2.33-.15-.63-.21-1.38-.2-2.26l2.67-.52c-.03.56-.01 1.03.08 1.4.17.74.53 1.2 1.07 1.38.54.17 1.21.17 2 0l10.21-2.25.7 2.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-33",
    className: "participate_svg__st1",
    d: "m-65.43 48.67-2.43.97-3.41-9.27 14.88-5.94 3.37 9.18-2.45.98-2.22-6.05-3.6 1.44 2.04 5.54-2.43.96-2.03-5.53-3.98 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-35",
    className: "participate_svg__st1",
    d: "m-62.73 60.29-1.7-2.84 11.81-6.98-2.4-4.01 2.33-1.38 6.52 10.9-2.33 1.38-2.42-4.05z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-37",
    className: "participate_svg__st1",
    d: "m-50.12 74.74-7.46-8.62 2.16-1.82 11.77-1.11c.37-.04.68-.07.94-.08.26-.01.5 0 .73.05a1.34 1.34 0 0 1-.23-.19c-.12-.14-.22-.25-.3-.33-.08-.08-.17-.18-.26-.27L-47 57.48l2.06-1.74 7.14 8.25-2.34 1.98-11.94 1.16c-.41.05-.81.05-1.19.02.29.26.56.53.81.82l4.39 5.07-2.05 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-39",
    className: "participate_svg__st1",
    d: "m-42.09 81.58-2.56-2.09 8.78-10.4-3.61-2.95 1.73-2.05 9.83 8.01-1.74 2.05-3.64-2.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-41",
    className: "participate_svg__st1",
    d: "M-10.98 98.31-14 97.1l3.47-9.01c.57-1.35 1.17-2.7 1.78-4.04l-.09-.03c-.38.54-.73 1.01-1.06 1.41l-8.25 10.02-2.78-1.12.44-10.83c.06-1.35.18-2.69.36-4.01l-.09-.04c-.42 1.53-.86 2.9-1.32 4.1l-3.51 9.13-2.87-1.15 5.87-15.26 4.77 1.91-.37 9.1c-.07 1.46-.23 2.84-.48 4.14.38-.59.72-1.09 1.02-1.52.3-.42.62-.84.96-1.26l6.2-7.52 4.84 1.94-5.87 15.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-43",
    className: "participate_svg__st1",
    d: "m-1.95 99.83-3.16-.61 2.92-16.12 3.16.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-45",
    className: "participate_svg__st1",
    d: "m9.01 101.35-3.33-.18.76-13.61-4.71-.25.15-2.69 12.78.7-.15 2.68-4.74-.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-47",
    className: "participate_svg__st1",
    d: "m35.95 98.31-3.19.54-1.57-9.43c-.19-1.44-.36-2.89-.51-4.35l-.09.02c-.05.66-.11 1.24-.2 1.74l-2 12.77-2.93.5-5.07-9.4c-.63-1.17-1.2-2.37-1.71-3.58l-.09.02c.41 1.52.72 2.9.93 4.16l1.59 9.55-3.03.52-2.66-15.97 5.04-.86 4.26 7.89c.67 1.27 1.23 2.52 1.67 3.75.03-.69.06-1.3.11-1.82.04-.52.11-1.04.18-1.56l1.52-9.59 5.1-.87 2.65 15.97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-49",
    className: "participate_svg__st1",
    d: "m46.86 87.06-4.27-4.25c-.1-.09-.34-.37-.73-.82.04.24.08.49.13.73.04.25.07.44.09.6l.44 5.59 4.34-1.85zm8.11 3.27-3.29 1.4-2.81-2.7-6.18 2.63.23 3.8-3.12 1.33-.8-16.82 3.36-1.43 12.61 11.79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-51",
    className: "participate_svg__st1",
    d: "m65.37 79.43 1.76 2.25c-.92 1.04-1.85 1.88-2.78 2.5-1.06.71-2.14 1.23-3.23 1.57a8.33 8.33 0 0 1-3.27.36c-1.08-.09-2.1-.43-3.06-1-.96-.57-1.82-1.39-2.59-2.46-.77-1.07-1.29-2.14-1.57-3.2-.28-1.07-.31-2.1-.1-3.11.21-1.01.66-1.96 1.33-2.85.68-.89 1.56-1.7 2.66-2.44.98-.66 2.21-1.2 3.69-1.63l1.4 2.39c-1.24.13-2.38.54-3.42 1.24-.89.6-1.54 1.3-1.95 2.12-.41.82-.56 1.68-.45 2.58.11.9.48 1.78 1.09 2.64.64.89 1.41 1.56 2.3 2.02.89.45 1.83.64 2.81.56.98-.08 1.95-.44 2.89-1.07.91-.59 1.73-1.42 2.49-2.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-53",
    className: "participate_svg__st1",
    d: "m80.06 69.94-2.25 2.36-4.99-4.81-4.43 4.64 5 4.81-2.25 2.36-11.61-11.17 2.25-2.36 4.71 4.54 4.43-4.65-4.72-4.53 2.25-2.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-55",
    className: "participate_svg__st1",
    d: "m86.28 55.35 2.15 1.43-5.1 8.07-13.16-8.73 5.05-8 2.16 1.44-3.32 5.27 3.18 2.11 3.04-4.82 2.15 1.42-3.04 4.82 3.52 2.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-57",
    className: "participate_svg__st1",
    d: "m96.03 39.65-1.45 3.63-10.94 1.29c-.69.09-1.73.14-3.13.18 1.64.4 2.96.8 3.97 1.2l7.79 3.13-1.14 2.86-14.87-5.97 1.42-3.55 11-1.42c.39-.05.66-.07.82-.07H91.76c-1.11-.23-2.36-.63-3.75-1.19l-8-3.21 1.14-2.86 14.88 5.98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-59",
    className: "participate_svg__st1",
    d: "m95.37 29.92 2.94.66-.72 3.1-2.94-.66.72-3.1zm-1.72-.06-.58 2.51-11.48-2.02.82-3.52 11.24 3.03z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "participate_svg__Group-3",
    transform: "translate(61 82)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "participate_svg__Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -84.61,
    y: -90.72,
    width: 95.06,
    height: 84.41
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -84.61,
    y: -90.72,
    width: 95.06,
    height: 84.41,
    id: "participate_svg__mask-3_00000052091819865876022060000018233850720030644887_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#participate_svg__Adobe_OpacityMaskFilter)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__path-2_00000124138125050726970280000013301450324515379352_",
    className: "participate_svg__st0",
    d: "M-84.61-89.64h95.05v84.41h-95.05z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "participate_svg__Fill-1_00000082362881993758702070000011273392072511645116_",
    d: "M-49.46-15.62c-.4.39-.83.6-1.23.6-.16 0-.33-.04-.49-.11a1.65 1.65 0 0 1-.46-.32c-.36-.37-.55-.89-.55-1.47l-.03-12.36 9.7 6.68-6.94 6.98zm-.84-16.69 37.72-33.42a1.784 1.784 0 0 0 .22-2.42 1.84 1.84 0 0 0-1.04-.66c-.42-.09-.86-.02-1.24.2l-48.31 28.14-.11-.07L-81-52.74a.975.975 0 0 1-.34-.39 1.2 1.2 0 0 1-.07-.61c.03-.22.1-.42.21-.57.11-.14.26-.26.44-.32L6.07-87.46c.17-.06.33-.08.48-.05.14.03.29.12.42.25.13.14.23.31.27.49.04.2.03.41-.03.62l-23.94 75.89c-.05.17-.14.32-.25.44a.85.85 0 0 1-.37.24c-.11.04-.21.06-.31.06-.03 0-.06 0-.09-.01a.789.789 0 0 1-.35-.13l-.18-.12v-.01l-32.24-22.35.22-.17zm10.65 11.59 19.74 13.68.02.01c.56.38 1.16.61 1.78.69.62.07 1.26-.01 1.88-.24a4.12 4.12 0 0 0 1.59-1.06c.42-.46.74-1.01.94-1.65l23.94-75.89c.24-.76.28-1.55.11-2.3-.17-.76-.55-1.45-1.1-2.02-.56-.57-1.25-.96-2-1.13a3.96 3.96 0 0 0-2.28.17l-86.83 32.84c-.73.28-1.37.75-1.84 1.36-.47.61-.77 1.35-.86 2.13-.1.78.02 1.57.32 2.27.31.72.82 1.34 1.47 1.78l19.69 13.39 35.9-20.91.23.32-.1.08-28.36 25.12.03 15.12c-.01 1.43.51 2.75 1.46 3.72.43.44.91.78 1.45 1.01.56.25 1.15.37 1.77.37h.02c1.26 0 2.45-.53 3.46-1.52l.03-.02 7.4-7.45.14.13z",
    style: {
      mask: "url(#participate_svg__mask-3_00000052091819865876022060000018233850720030644887_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#476e97"
    }
  })))))));
};
export default SvgParticipate;